import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-input-currency-text',
  templateUrl: './st-input-currency-text.component.html',
  styleUrls: ['./st-input-currency-text.component.scss'],
  standalone: false
})
export class StInputCurrencyTextComponent {

  @Input()
  label = 'FIELD LABEL';

  @Input()
  idVal: string = 'textId';

  @Input()
  inputVal: string = '';

  @Input()
  currencySymbolVal: string = '';

  @Input()
  placeHolderVal = 'Type here';

  @Input()
  disabled: boolean = false;

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Input()
  requiredVal: boolean = false;

  @Output()
  onClick = new EventEmitter<Event>();
}
